interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  isActive?: boolean;
}

export function Overlay({ isActive = true }: OverlayProps) {
  if (!isActive) {
    return null;
  }

  return (
    <div
      aria-hidden
      className="bg-black/40 w-full h-full z-[1040] fixed inset-0"
      onClick={event => {
        event.stopPropagation();
      }}
      onTouchStart={event => {
        event.stopPropagation();
      }}
    />
  );
}
